import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Svg from './Svg';

const ConfirmDialog = ({ message, onClose, onConfirm, submitting }) => (
  <div className={`confirm-dialog validation-container is-modal`}>
    <div className="validation-inner">

      <div className="message">{message}</div>

      <button disabled={submitting} className={`btn btn-warning-primary btn-with-svg ${!submitting ? null : 'fake-disabled'}`} type="button" onClick={onConfirm}>
        Confirm
        {submitting && (<Svg name={'spinner'} spin={true} />)}
      </button>

      <button type="button" className={`btn btn-primary ${!submitting ? null : 'fake-disabled'}`} onClick={onClose}>
        Close
      </button>

    </div>
  </div>
);

ConfirmDialog.propTypes = {
  message: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

ConfirmDialog.defaultProps = {
  isModal: false,
  submitting: false,
  onClose: () => {},
  onConfirm: () => {},
};

export default memo(ConfirmDialog);
